<div class="bg-primary p-4 text-white">
  <h2>Job Details</h2>
</div>
<form [formGroup]="form">
  <div class="flex flex-col md:flex-row gap-8 p-4">
    <div class="flex flex-col gap-4 md:w-1/2">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Client Purchase Order</mat-label>
        <input matInput formControlName="clientPurchaseOrder" />
      </mat-form-field>

      <div class="flex items-end gap-2">
        <mat-form-field appearance="fill" class="flex-1">
          <mat-label>{{ priceLabel }}</mat-label>
          <input matInput formControlName="pricePerUnit" type="number" />
        </mat-form-field>
        <span class="pb-2 text-xs">{{ priceSuffix }}</span>
      </div>

      <mat-form-field *ngIf="!isOrdersManager()" appearance="fill" class="w-full">
        <mat-label>Order Total Price</mat-label>
        <input matInput formControlName="orderTotalPrice" type="number" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Total Quantity</mat-label>
        <input matInput formControlName="totalQuantity" type="number" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Balance To Follow</mat-label>
        <input matInput formControlName="balanceToFollow" type="number" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Overage</mat-label>
        <input matInput formControlName="overage" type="number" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Weeks Amount</mat-label>
        <mat-select formControlName="weeksAmount" (selectionChange)="onWeeksAmountChange($event)">
          <mat-option *ngFor="let week of weeksOptions; trackBy: trackByValue" [value]="week.value"
            >{{ week.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Estimated Ship Date</mat-label>
        <input matInput [matDatepicker]="shipDatePicker" formControlName="promisedDate" />
        <mat-datepicker-toggle matSuffix [for]="shipDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #shipDatePicker></mat-datepicker>
      </mat-form-field>

      @if (!viewDisabled) {
        <mat-checkbox formControlName="expeditedOrder">Expedited Order?</mat-checkbox>
      }

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Expedite Date</mat-label>
        <input matInput [matDatepicker]="expediteDatePicker" formControlName="expediteDate" />
        <mat-datepicker-toggle matSuffix [for]="expediteDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #expediteDatePicker></mat-datepicker>
      </mat-form-field>

      <ng-container *ngIf="form.get('expeditedOrder')?.value">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>Expedite Price</mat-label>
          <input matInput formControlName="expeditePrice" type="number" />
        </mat-form-field>
      </ng-container>

      @if (!viewDisabled) {
        <mat-checkbox formControlName="faiReport">FAI Report?</mat-checkbox>
      }

      <ng-container *ngIf="form.get('faiReport')?.value">
        <mat-form-field appearance="fill" class="w-full">
          <mat-label>FAI Report Price</mat-label>
          <input matInput formControlName="faiReportPrice" type="number" />
        </mat-form-field>
      </ng-container>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Last Shipment Amount</mat-label>
        <input matInput formControlName="lastShipmentAmount" type="number" />
      </mat-form-field>
    </div>

    <div>
      <div>
        <ciwc-order-attachments
          [attachments]="attachments"
          [viewDisable]="viewDisabled"
          [parentForm]="form"
        ></ciwc-order-attachments>
      </div>

      <div class="flex flex-col gap-2 pt-2">
        <mat-checkbox formControlName="testReports">Test Reports Needed</mat-checkbox>
        <mat-checkbox formControlName="certsRequired">Certs Required</mat-checkbox>
        <mat-checkbox formControlName="cfm">CFM</mat-checkbox>
        <mat-checkbox formControlName="ciwToSupplyWire">CIW To supply wire</mat-checkbox>
        <mat-checkbox formControlName="isComplete">Order Complete</mat-checkbox>

        @if (viewDisabled) {
          <mat-checkbox formControlName="expeditedOrder">Expedited Order?</mat-checkbox>
          <mat-checkbox formControlName="faiReport">FAI Report?</mat-checkbox>
        }
      </div>
    </div>
  </div>

  <mat-form-field appearance="fill" class="w-full mt-4">
    <mat-label>Shipping Details</mat-label>
    <textarea
      matInput
      formControlName="shippingDetailsText"
      rows="3"
      placeholder="Enter shipping details..."
    ></textarea>
  </mat-form-field>
</form>
